import type { EmailStyleSettings } from "../../style-settings";
import { normalizeImageHref } from "../../utils";
import { storedAttributeProps } from "../html-attributes";
import { Img } from "@react-email/components";
import type { CSSProperties } from "react";
import { getImageStyles } from "./styles";
export function imageEmailRenderer(attrs: Record<string, unknown>, _children?: React.ReactElement, settings?: Partial<EmailStyleSettings>) {
  const src = attrs.src as string;
  // Skip rendering if no image source (e.g. AI-generated placeholders with src="")
  if (!src) return <></>;
  const styles = getImageStyles(attrs, settings);
  const alt = attrs.alt as string ?? "";
  const attributeProps = storedAttributeProps(attrs);
  const href = normalizeImageHref(attrs.href as string);
  if (!href) {
    return <Img src={src} alt={alt} {...attributeProps} style={styles} />;
  }
  const anchorStyles: CSSProperties = {
    display: styles.display || "block",
    textDecoration: "none",
    width: styles.width,
    margin: styles.margin
  };
  const imageStyles: CSSProperties = {
    ...styles,
    display: "block",
    width: styles.width === "auto" ? "auto" : "100%",
    margin: "0"
  };
  return <a href={href} target="_blank" rel="noopener noreferrer" style={anchorStyles}>
      <Img src={src} alt={alt} {...attributeProps} style={imageStyles} />
    </a>;
}